/**
 * src/js/main.js
 *
 * main javascript file
 */
function APP() {

  var self = this;

  self.debug = false;

  this.init = function() {

    if (this.debug) {
      console.log('APP::init');
    }

    this.pageInit();

    $(document).foundation();
  };

  this.pageInit = function() {

    if (this.debug) {
      console.log('APP::pageInit');
    }

    document.body.classList.add('page-has-loaded');

    this.main();
  };

  this.main = function() {

    $(document).on('click', '.main-nav a[href="#contact"]', function(e) {
      e.preventDefault();
      console.log(window.location.protocol);
      window.location.href = window.location.protocol + "//" + window.location.host + '/#contact-anchor';
      // window.location.replace(window.location.host + '/#contact');
    });

    /**
     * Map set-up
     */
    if ($('#map').length) {
      mapInit();
    }

    function mapInit() {
      var location = [9.956740099999934, 48.3988716];

			var mapEl = document.getElementById('map');
			var style = 'mapbox://styles/mapbox/streets-v11';

			mapboxgl.accessToken = 'pk.eyJ1IjoiaGFubmVueiIsImEiOiJPMktpVm1BIn0.qMq_8uPobOFc-eBXIFVtog';
			var map = new mapboxgl.Map({
				container: mapEl,
				style: style, // stylesheet location
				center: location, // starting position [lng, lat]
				zoom: 14, // starting zoom
				interactive: false,
			});

			var popUp = "<p><strong>GeoBüro Ulm</strong><br>Magirus-Deutz-Straße 9<br>89077 Ulm</p><p>Tel.: <a href='tel:+49 (0)731 140 206-0'>+49 (0)731 140 206-0</a><br>E-Mail: <a href='mailto:post@geoulm.de'>post@geoulm.de</a></p>";

			var popup = new mapboxgl.Popup({ closeOnMove: false, offset: 41, focusAfterOpen: false })
			.setLngLat(location)
			.setHTML(popUp)
			.addTo(map)

			var icon = document.createElement('div');
			icon.innerHTML = "<img src='/dist/img/marker-icon.png'/>"

			var marker = new mapboxgl.Marker({element: icon, anchor: 'bottom',})
				.setLngLat(location)
				.setPopup(popup)
				.addTo(map);

			marker.togglePopup();

			var nav = new mapboxgl.NavigationControl();
			map.addControl(nav, 'top-left');

			// Click to activate
			mapEl.addEventListener('click', function() {
				map.dragPan.enable();
				map.dragRotate.enable();
				map.scrollZoom.enable({ around: 'center' }); //{ around: 'center' }

				map.touchZoomRotate.enable();
				map.touchPitch.enable();
			});

			// Click anywhere to deactivate
			$("body").click(function (event) {
				var target = $(event.target);
				if (!target.parents('#map').length) {
					map.dragPan.disable();
					map.dragRotate.disable();
					map.scrollZoom.disable();

					map.touchZoomRotate.disable();
					map.touchPitch.disable();
				}
			});
    }

    // Lazy loading images
    // this.bLazy = new Blazy({
    // 	selector: '.lazy',
    // 	offset: 100,
    // 	successClass: 'lazy--loaded',
    // 	errorClass: 'lazy--failed',
    // 	error: function(el) {
    // 	 	el.src = '/img/noimage.svg';
    // 	}
    // });

    var mySwiper = new Swiper('.swiper-container', {
      loop: true,
      parallax: true,
      effect: 'fade',
      speed: 800,
      autoplay: {
        delay: 6000,
      },
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: true
    });
    mySwiper.on('slideChange', function(e) {
      var i = mySwiper.activeIndex;
      // fix values for looping slides
      var count = $('.swiper-slide:not(.swiper-slide-duplicate)').length;
      i = (i === -1) ? count : i;
      i = (i > count) ? 1 : i;
      $('.project-desc-item').removeClass('is-active').eq(i - 1).toggleClass('is-active');
    });

    // mobile header scroll
    console.log(Foundation)
    // var menuBtn = document.getElementsByClassName('menu-icon');
    // menuBtn.onClick = function() {
    //
    // }
    $(document).on('click', '.mobile-menu', function(e) {
      e.preventDefault();
      $('.js-drilldown-back > a').html('Zurück');
      if (!$('#main-menu').hasClass('open')) {
        $('#main-menu').addClass('open');
        $('.mobile-menu').addClass('is-active');
      } else {
        $('#main-menu').removeClass('open');
        $('.mobile-menu').removeClass('is-active');
      }
    });

    if (/Edge/.test(navigator.userAgent)) {
      $(document).on('click', '.is-submenu-item > a', function(e) {
          e.preventDefault();
          window.location.href = location.protocol + '//' + window.location.hostname + $(e.target).attr('href');
        }
      );
    }

  };
};

document.addEventListener('DOMContentLoaded', function() {

  var app = new APP();
  app.init();

});
